export default {
  tc: {
    title: '用戶登記',
    mandatory: '* 必填',
    firstname: '名字 *',
    lastname: '姓氏 *',
    email: '電郵地址 *',
    confirmEmail: '確認電郵地址 *',
    phone: '手提電話號碼 *',
    verificationCode: '驗證碼 *',
    getSMSCode: '獲取SMS驗證碼',
    codeSent: '已傳送驗證碼',
    gender: '性別 *',
    genderNotSelected: '請選擇性別以繼續',
    male: '男',
    female: '女',
    selectAgeGroup: '請選擇年齡組別 *',
    ageGroup: '年齡組別',
    selectBirthdayMonth: '請選擇生日月份 *',
    birthdayMonth: '生日月份',
    jan: '一月',
    feb: '二月',
    mar: '三月',
    apr: '四月',
    may: '五月',
    jun: '六月',
    jul: '七月',
    aug: '八月',
    sept: '九月',
    oct: '十月',
    nov: '十一月',
    dec: '十二月',
    region: '居住區域',
    selectRegion: '請選擇居住區域 *',
    hongkong: '香港',
    macau: '澳門',
    china: '中國',
    others: '其他',
    district: '居住地區',
    selectDistrict: '請選擇居住地區',
    workingDistrict: '工作地區',
    selectWorkingDistrict: '請選擇工作地區',
    CentralandWesternDistrict: "中西區",
    WanChaiDistrict: "灣仔區",
    EasternDistrict: "東區",
    SouthernDistrict: "南區",
    ShamShuiPoDistrict: "深水埗區",
    YauTsimMongDistrict: "油尖旺區",
    KowloonCityDistrict: "九龍城區",
    WongTaiSinDistrict: "黃大仙區",
    KwunTongDistrict: "觀塘區",
    NorthDistrict: "北區",
    TaiPoDistrict: "大埔區",
    ShaTinDistrict: "沙田區",
    SaiKungDistrict: "西貢區",
    YuenLongDistrict: "元朗區",
    TuenMunDistrict: "屯門區",
    TsuenWanDistrict: "荃灣區",
    KwaiTsingDistrict: "葵青區",
    IslandsDistrict: "離島區",
    selectLang: '請選擇首選語言',
    english: 'English',
    traditionalChinese: '繁體中文',
    simplifiedChinese: '简体中文',
    termAndCondition1: '本人確認本人已詳閲及明白本網站及用戶之',
    termAndCondition2: '條款及細則',
    termAndCondition3: '、',
    termAndCondition4: '私隱政策聲明及個人資料收集聲明',
    termAndCondition5: '。本人同意接受並遵從條款及細則及同意個人資料收集聲明所指明的用途。',
    personalStatement: '本人確認本人已仔細閱讀「個人資料收集聲明」內的「使用個人資料作直接促銷」的條文，並且明白本網站可以如何使用本人的個人資料作直接促銷用途，以及直接促銷的範圍。本人同意透過電郵、電話、SMS及推送訊息收取有關新地商場的直接促銷資訊 (包括推廣活動、服務及產品)。',
    notAccepted: '閣下必須同意本網站之條款及細則及私隱聲明方可完成登記。',
    submit: '提交',
    registrationSuccess: '登記成功',
    confirm: '確認'
  },
  sc: {
    title: '用户登记',
    mandatory: '* 必填',
    firstname: '名字 *',
    lastname: '姓氏 *',
    email: '电邮地址 *',
    confirmEmail: '确认电邮地址 *',
    phone: '流动电话号码 *',
    verificationCode: '验证码 *',
    getSMSCode: '获取SMS验证码',
    codeSent: '已发送验证码',
    gender: '性別 *',
    genderNotSelected: '请选择性別以继续',
    male: '男',
    female: '女',
    selectAgeGroup: '请选择年龄组别 *',
    ageGroup: '年龄组别',
    selectBirthdayMonth: '请选择生日月份 *',
    birthdayMonth: '生日月份',
    jan: '一月',
    feb: '二月',
    mar: '三月',
    apr: '四月',
    may: '五月',
    jun: '六月',
    jul: '七月',
    aug: '八月',
    sept: '九月',
    oct: '十月',
    nov: '十一月',
    dec: '十二月',
    region: '居住区域',
    selectRegion: '请选择居住区域 *',
    hongkong: '香港',
    macau: '澳门',
    china: '中国',
    others: '其他',
    district: '居住地区',
    selectDistrict: '请选择居住地区',
    CentralandWesternDistrict: "中西区",
    WanChaiDistrict: "湾仔区",
    EasternDistrict: "东区",
    SouthernDistrict: "南区",
    ShamShuiPoDistrict: "深水埗区",
    YauTsimMongDistrict: "油尖旺区",
    KowloonCityDistrict: "九龙城区",
    WongTaiSinDistrict: "黄大仙区",
    KwunTongDistrict: "观塘区",
    NorthDistrict: "北区",
    TaiPoDistrict: "大埔区",
    ShaTinDistrict: "沙田区",
    SaiKungDistrict: "西贡区",
    YuenLongDistrict: "元朗区",
    TuenMunDistrict: "屯门区",
    TsuenWanDistrict: "荃湾区",
    KwaiTsingDistrict: "葵青区",
    IslandsDistrict: "离岛区",
    workingDistrict: '工作地区',
    selectWorkingDistrict: '请选择工作地区',
    selectLang: '请选择首选语言',
    english: 'English',
    traditionalChinese: '繁體中文',
    simplifiedChinese: '简体中文',
    termAndCondition1: '本人确认本人已详阅及明白本网站及用户之',
    termAndCondition2: '条款及细则',
    termAndCondition3: '、',
    termAndCondition4: '私隐政策声明及个人资料收集声明',
    termAndCondition5: '。本人同意接受并遵从条款及细则及同意个人资料收集声明所指明的用途。',
    personalStatement: '本人确认本人已仔细阅读「个人资料收集声明」内的「使用个人资料作直接促销」的条文，并且明白本网站可以如何使用本人的个人资料作直接促销用途，以及直接促销的范围。本人同意透过电邮、电话、SMS及推送讯息收取有关新地商场的直接促销资讯 (包括推广活动、服务及产品)。',
    notAccepted: '阁下必须同意本网站之条款及细则及私隐声明方可完成登记。',
    submit: '提交',
    registrationSuccess: '登记成功',
    confirm: '确认'
  },
  en: {
    title: 'User Registration',
    mandatory: '* Mandatory',
    firstname: 'First Name *',
    lastname: 'Last Name *',
    email: 'Email address *',
    confirmEmail: 'Confirm your email address *',
    phone: 'Mobile phone no. *',
    verificationCode: 'Verification code *',
    getSMSCode: 'Get SMS verification code',
    codeSent: 'Verification code sent',
    gender: 'Gender *',
    genderNotSelected: 'Select gender to continue',
    male: 'Male',
    female: 'Female',
    selectAgeGroup: 'Age Group *',
    ageGroup: 'Age Group',
    selectBirthdayMonth: 'Birthday Month *',
    birthdayMonth: 'Birthday Month',
    jan: 'January',
    feb: 'February',
    mar: 'March',
    apr: 'April',
    may: 'May',
    jun: 'June',
    jul: 'July',
    aug: 'August',
    sept: 'September',
    oct: 'October',
    nov: 'November',
    dec: 'December',
    region: 'Residential Region',
    selectRegion: 'Residential Region *',
    hongkong: 'Hong Kong',
    macau: 'Macau',
    china: 'China',
    others: 'Others',
    district: 'Residential District',
    selectDistrict: 'Residential District',
    CentralandWesternDistrict: "Central and Western District",
    WanChaiDistrict: "Wan Chai District",
    EasternDistrict: "Eastern District",
    SouthernDistrict: "Southern District",
    ShamShuiPoDistrict: "Sham Shui Po District",
    YauTsimMongDistrict: "Yau Tsim Mong District",
    KowloonCityDistrict: "Kowloon City District",
    WongTaiSinDistrict: "Wong Tai Sin District",
    KwunTongDistrict: "Kwun Tong District",
    NorthDistrict: "North District",
    TaiPoDistrict: "Tai Po District",
    ShaTinDistrict: "Sha Tin District",
    SaiKungDistrict: "Sai Kung District",
    YuenLongDistrict: "Yuen Long District",
    TuenMunDistrict: "Tuen Mun District",
    TsuenWanDistrict: "Tsuen Wan District",
    KwaiTsingDistrict: "Kwai Tsing District",
    IslandsDistrict: "Islands District",
    workingDistrict: 'Working District',
    selectWorkingDistrict: 'Working District',
    selectLang: 'Prerferred Language',
    english: 'English',
    traditionalChinese: '繁體中文',
    simplifiedChinese: '简体中文',
    termAndCondition1: 'I confirm that I have read and understood the website’s and users’ ',
    termAndCondition2: 'Terms and Conditions',
    termAndCondition3: ', ',
    termAndCondition4: 'Privacy Policy Statement and Personal Information Collection Statement',
    termAndCondition5: '. I agree to be bound by such Terms and Conditions and consent to the uses specified in the Personal Information Collection Statement therein.',
    personalStatement: 'I confirm that I have read carefully the “Use of personal data in direct marketing” section in the Personal Information Collection Statement and I understand how the website may use my personal data for direct marketing purpose and the scope of direct marketing. I agree to receive direct marketing information (including promotional activities, services and products) relating to the SHKP Malls through email, telephone, SMS and push notification.',
    notAccepted: 'You must agree with the website’s Terms and Conditions and Privacy Statement to proceed with the member registration.',
    submit: 'Submit',
    registrationSuccess: 'Registration success',
    confirm: 'Confirm'
  }
};

